import { Component, OnInit, Input } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EOtpremnicaStavka } from './eotpremnica-stavka';
import { EOtpremnicaStavkaDodatniAtribut } from './eotpremnica-stavka-dodatni-atribut';

@Component({
  selector: 'yt-eotpremnica-stavka-dodatni-atribut-inline-update',
  templateUrl: './eotpremnica-stavka-dodatni-atribut-inline-update.component.html'
})
export class EOtpremnicaStavkaDodatniAtributInlineUpdateComponent
 extends BaseInlineUpdateComponent<EOtpremnicaStavkaDodatniAtribut> {
  constructor(protected inlineContainerService: InlineContainerService<EOtpremnicaStavkaDodatniAtribut>){
    super(inlineContainerService);
  }

  @Input() Disabled: boolean = false;

  //  izlazna: boolean = false;
  //  ngAfterViewInit() {
  //     if (this.baseUpdateComponent.modelData)
  //       this.izlazna = this.baseUpdateComponent.modelData.MainList.FormControlDataName == "eotpremnice/uleotpremnicastavkadodatniatribut";
  // }

}
